import React, { useEffect, useState } from "react";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import style from "assets/jss/material-kit-pro-react/views/componentsSections/contentAreas.js";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import { makeStyles } from "@material-ui/core";
import get from "lib/requests";
import Select from "@material-ui/core/Select";
import CustomInput from "components/CustomInput/CustomInput.js";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Layout from "./Layout";
import { ErrorMessage } from "components/Common/toastify";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import classNames from "classnames";
import Loading from "components/Common/loading";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import Table from "components/Table/Table.js";
import Button from "components/CustomButtons/Button.js";
import { Edit, Delete, PersonAdd } from "@material-ui/icons";
import MenuItem from "@material-ui/core/MenuItem";
import Pagination from "components/Common/pagination.jsx";
import { useNavigate } from "react-router-dom";
import { delete_ } from "lib/requests";
import { LoadingMgs } from "components/Common/toastify";
import { SuccessMessage } from "components/Common/toastify";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import { useSelector } from "react-redux";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { post } from "lib/requests";

const useStyles2 = makeStyles(headersStyle);
const useStyles3 = makeStyles(basicsStyle);
const useStyles = makeStyles(style);
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

export default function SubscriptionUpgrade() {
	const classes2 = useStyles2();
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const [toSubscription, setToSubscription] = useState("");
	const [loading, setLoading] = useState(false);
	const [quantity, setQuantity] = useState(1);
	const [termDuration, setTermDuration] = useState("");
	const [billingCycle, setBillingCycle] = useState("");
	const classes3 = useStyles3();
	const navigate = useNavigate();
	const upgradeToResponse = {
		tenantId: "8AF3CD5B-EBDE-4942-9A45-D6C4C2025E78",
		subscription_id: "62297d4e-a9f2-42e8-ce98-e6c222eca456",
		subscriptions: [
			{
				CatalogItemId: "CFQ7TTC0LH16:0001:CFQ7TTC0PRP2",
				Title: "Exchange Online (Plan 1)",
				Description:
					"Messaging, calendaring, and email archiving plan accessible from Outlook on PCs, the Web and mobile devices.",
				Quantity: 1,
				Eligibilities: [
					{
						IsEligible: true,
						TransitionType: "transition_only",
						Errors: [],
					},
					{
						IsEligible: false,
						TransitionType: "transition_with_license_transfer",
						Errors: [
							{
								Code: 13,
								Description:
									"Subscription cannot be transitioned because the partner does not have sufficient permissions to perform the operation.",
							},
						],
					},
				],
			},
			{
				CatalogItemId: "CFQ7TTC0LH1P:0001:CFQ7TTC0S3S8",
				Title: "Exchange Online (Plan 2)",
				Description:
					"Best messaging and calendaring plan accessible from PCs, the Web and mobile devices with advanced archiving, compliance and integrated voicemail capabilities.",
				Quantity: 1,
				Eligibilities: [
					{
						IsEligible: true,
						TransitionType: "transition_only",
						Errors: [],
					},
					{
						IsEligible: false,
						TransitionType: "transition_with_license_transfer",
						Errors: [
							{
								Code: 13,
								Description:
									"Subscription cannot be transitioned because the partner does not have sufficient permissions to perform the operation.",
							},
						],
					},
				],
			},
			{
				CatalogItemId: "CFQ7TTC0LH18:0001:CFQ7TTC0PM1C",
				Title: "Microsoft 365 Business Basic",
				Description:
					"Best for businesses that need professional email, cloud file storage, and online meetings & chat. Desktop versions of Office apps like Excel, Word, and PowerPoint not included. For businesses with up to 300 employees.",
				Quantity: 1,
				Eligibilities: [
					{
						IsEligible: true,
						TransitionType: "transition_only",
						Errors: [],
					},
					{
						IsEligible: false,
						TransitionType: "transition_with_license_transfer",
						Errors: [
							{
								Code: 13,
								Description:
									"Subscription cannot be transitioned because the partner does not have sufficient permissions to perform the operation.",
							},
						],
					},
				],
			},
			{
				CatalogItemId: "CFQ7TTC0LCHC:0002:CFQ7TTC0Z35S",
				Title: "Microsoft 365 Business Premium",
				Description:
					"Best for businesses that need all the apps and services included in Business Standard plus advanced cyber threat protection and device management. For businesses with up to 300 employees.",
				Quantity: 1,
				Eligibilities: [
					{
						IsEligible: true,
						TransitionType: "transition_only",
						Errors: [],
					},
					{
						IsEligible: false,
						TransitionType: "transition_with_license_transfer",
						Errors: [
							{
								Code: 13,
								Description:
									"Subscription cannot be transitioned because the partner does not have sufficient permissions to perform the operation.",
							},
						],
					},
				],
			},
			{
				CatalogItemId: "CFQ7TTC0LDPB:0001:CFQ7TTC0XZKX",
				Title: "Microsoft 365 Business Standard",
				Description:
					"Best for businesses that need Office apps across devices plus professional email, cloud file storage, and online meetings & chat. For businesses with up to 300 employees.",
				Quantity: 1,
				Eligibilities: [
					{
						IsEligible: true,
						TransitionType: "transition_only",
						Errors: [],
					},
					{
						IsEligible: false,
						TransitionType: "transition_with_license_transfer",
						Errors: [
							{
								Code: 13,
								Description:
									"Subscription cannot be transitioned because the partner does not have sufficient permissions to perform the operation.",
							},
						],
					},
				],
			},
			{
				CatalogItemId: "CFQ7TTC0LFLX:0021:CFQ7TTC0WD4T",
				Title: "Microsoft 365 E3 (no Teams)",
				Description:
					"Office 365 E3 (no Teams), Enterprise Mobility + Security E3, Windows 10/11 Enterprise E3, and more. For Remote Process Automation (RPA). Does not include Microsoft Teams. This licensed suite of products offers users best-in-class productivity across devices while providing IT security and control. This per-user licensed suite of products offers users best-in-class productivity across devices while providing IT security and control.",
				Quantity: 1,
				Eligibilities: [
					{
						IsEligible: true,
						TransitionType: "transition_only",
						Errors: [],
					},
					{
						IsEligible: false,
						TransitionType: "transition_with_license_transfer",
						Errors: [
							{
								Code: 13,
								Description:
									"Subscription cannot be transitioned because the partner does not have sufficient permissions to perform the operation.",
							},
						],
					},
				],
			},
			{
				CatalogItemId: "CFQ7TTC0LFLZ:001L:CFQ7TTC0W3PS",
				Title: "Microsoft 365 E5 (no Teams)",
				Description:
					"Office 365 E5, Enterprise Mobility + Security E5, and Windows 10/11 Enterprise E5. This per-user licensed suite of products offers customers the latest, most advanced enterprise security, management, collaboration, and business analytics. Does not include Microsoft Teams. Some features may require Teams Enterprise Standalone.",
				Quantity: 1,
				Eligibilities: [
					{
						IsEligible: true,
						TransitionType: "transition_only",
						Errors: [],
					},
					{
						IsEligible: false,
						TransitionType: "transition_with_license_transfer",
						Errors: [
							{
								Code: 13,
								Description:
									"Subscription cannot be transitioned because the partner does not have sufficient permissions to perform the operation.",
							},
						],
					},
				],
			},
			{
				CatalogItemId: "CFQ7TTC0MBMD:0002:CFQ7TTC084VB",
				Title: "Microsoft 365 F1",
				Description:
					"Core products and features within Microsoft 365 to equip Firstline Workers",
				Quantity: 1,
				Eligibilities: [
					{
						IsEligible: true,
						TransitionType: "transition_only",
						Errors: [],
					},
					{
						IsEligible: false,
						TransitionType: "transition_with_license_transfer",
						Errors: [
							{
								Code: 13,
								Description:
									"Subscription cannot be transitioned because the partner does not have sufficient permissions to perform the operation.",
							},
						],
					},
				],
			},
			{
				CatalogItemId: "CFQ7TTC0LH05:0001:CFQ7TTC0Z9CN",
				Title: "Microsoft 365 F3",
				Description:
					"Best-in-class productivity apps and services within Microsoft 365 for Firstline Workers",
				Quantity: 1,
				Eligibilities: [
					{
						IsEligible: true,
						TransitionType: "transition_only",
						Errors: [],
					},
					{
						IsEligible: false,
						TransitionType: "transition_with_license_transfer",
						Errors: [
							{
								Code: 13,
								Description:
									"Subscription cannot be transitioned because the partner does not have sufficient permissions to perform the operation.",
							},
						],
					},
				],
			},
			{
				CatalogItemId: "CFQ7TTC0LF8Q:001S:CFQ7TTC0P4B8",
				Title: "Office 365 E1 (no Teams)",
				Description:
					"The online versions of Office with email plus 1 TB personal file storage and sharing. Does not include the Office suite for PC or Mac. Does not include Microsoft Teams.",
				Quantity: 1,
				Eligibilities: [
					{
						IsEligible: true,
						TransitionType: "transition_only",
						Errors: [],
					},
					{
						IsEligible: false,
						TransitionType: "transition_with_license_transfer",
						Errors: [
							{
								Code: 13,
								Description:
									"Subscription cannot be transitioned because the partner does not have sufficient permissions to perform the operation.",
							},
						],
					},
				],
			},
			{
				CatalogItemId: "CFQ7TTC0LF8R:0020:CFQ7TTC0SKWF",
				Title: "Office 365 E3 (no Teams)",
				Description:
					"The Office suite for PC and Mac with apps for tablets and phones, email plus 1 TB personal file storage and sharing, and available add-ons like PSTN calling. Does not include Microsoft Teams.",
				Quantity: 1,
				Eligibilities: [
					{
						IsEligible: true,
						TransitionType: "transition_only",
						Errors: [],
					},
					{
						IsEligible: false,
						TransitionType: "transition_with_license_transfer",
						Errors: [
							{
								Code: 13,
								Description:
									"Subscription cannot be transitioned because the partner does not have sufficient permissions to perform the operation.",
							},
						],
					},
				],
			},
			{
				CatalogItemId: "CFQ7TTC0LF8S:001J:CFQ7TTC0SZR4",
				Title: "Office 365 E5 (no Teams)",
				Description:
					"The Office suite for PC and Mac, plus email, 1 TB personal file storage and sharing, and advanced security, analytics and Audio conferencing. Does not include Microsoft Teams. Some features may require Teams Enterprise Standalone.",
				Quantity: 1,
				Eligibilities: [
					{
						IsEligible: true,
						TransitionType: "transition_only",
						Errors: [],
					},
					{
						IsEligible: false,
						TransitionType: "transition_with_license_transfer",
						Errors: [
							{
								Code: 13,
								Description:
									"Subscription cannot be transitioned because the partner does not have sufficient permissions to perform the operation.",
							},
						],
					},
				],
			},
			{
				CatalogItemId: "CFQ7TTC0LGZW:0001:CFQ7TTC0MLFJ",
				Title: "Office 365 F3",
				Description:
					"Purpose-built tools and productivity experience for Firstline Workers.",
				Quantity: 1,
				Eligibilities: [
					{
						IsEligible: true,
						TransitionType: "transition_only",
						Errors: [],
					},
					{
						IsEligible: false,
						TransitionType: "transition_with_license_transfer",
						Errors: [
							{
								Code: 13,
								Description:
									"Subscription cannot be transitioned because the partner does not have sufficient permissions to perform the operation.",
							},
						],
					},
				],
			},
		],
		subscription: {
			id: "62297d4e-a9f2-42e8-ce98-e6c222eca456",
			entitlementId: null,
			offerId: "CFQ7TTC0LH0L:0001:CFQ7TTC0QV5N",
			offerName: "Exchange Online Kiosk",
			friendlyName: "Exchange Online Kiosk",
			quantity: 1,
			unitType: "Licenses",
			parentSubscriptionId: null,
			creationDate: "2025-01-29T01:24:43.3730883Z",
			effectiveStartDate: "2025-01-29T00:00:00Z",
			commitmentEndDate: "2026-01-28T00:00:00Z",
			cancellationAllowedUntilDate: "2025-02-05T01:25:04.6576028Z",
			status: "active",
			autoRenewEnabled: false,
			billingType: "license",
			billingCycle: "monthly",
			hasPurchasableAddons: false,
			termDuration: "P1Y",
			renewalTermDuration: "",
			refundableQuantity: null,
			isMicrosoftProduct: true,
			partnerId: "3875805",
			contractType: "subscription",
			publisherName: "Microsoft Corporation",
			promotionId: null,
			scheduledNextTermInstructions: null,
			orderId: "a770dcce140d",
		},
		compneyName: "Chris Mensforth",
		domain: "mensforth.com",
	};
	const [subscriptionDetails, setSubscriptionDetails] = useState([]);
	const subscriptionInfo = useSelector((state) => state.subscription);
	const customerDetails = useSelector((state) => state.customer);

	const handleTermDuration = (event) => {
		setTermDuration(event.target.value);
		setValue("termDuration", event.target.value);
	};
	const handleBillingCycle = (event) => {
		setBillingCycle(event.target.value);
		setValue("billingCycle", event.target.value);
	};

	const validationSchema = Yup.object().shape({
		quantity: Yup.string().required("Quantity is required"),
		termDuration: Yup.string().required("Term Duration is required"),
		billingCycle: Yup.string().required("Billing Cycle is required"),
	});
	const formOptions = { resolver: yupResolver(validationSchema) };

	// get functions to build form with useForm() hook
	const {
		register,
		handleSubmit,
		setError,
		setValue,
		reset,
		formState,
	} = useForm(formOptions);
	const { errors } = formState;

	async function onSubmit(formField) {
		formField.subscription_id = subscriptionInfo?.id;
		formField.quantity = quantity;
		formField.termDuration = termDuration;
		formField.billingCycle = billingCycle;
		formField.CatalogItemId = toSubscription;
		formField.targetsubscription = "";
		LoadingMgs("Subscription upgrade", "processing...");
		console.log("formField", formField);
		setLoading(true);

		try {
			await post(
				`/api/subscription/upgradeto${customerDetails?.tenantId}`,
				formField,
				true
			)
				.then((res) => {
					if (res.data.success) {
						SuccessMessage("Subscription upgrade", res.data.message);
						window.scrollTo(0, 0);
						document.body.scrollTop = 0;
						reset();
					} else {
						ErrorMessage("Subscription upgrade", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Subscription upgrade", message);
					setLoading(false);
				});
		} catch (error) {
			console.log("error", error);
			ErrorMessage("Subscription upgrade", "Something went wrong try again!!");
			setLoading(false);
		}
	}

	useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
		if (subscriptionInfo) {
			setQuantity(subscriptionInfo?.quantity);
			setTermDuration(subscriptionInfo?.termDuration);
			setBillingCycle(subscriptionInfo?.billingCycle);

			setValue("quantity", subscriptionInfo?.quantity);
			setValue("termDuration", subscriptionInfo?.termDuration);
			setValue("billingCycle", subscriptionInfo?.billingCycle);
		}
		getSubscriptions();
		return function cleanup() {};
	}, []);

	const getSubscriptions = async () => {
		setLoading(true);
		try {
			await get(
				`/api/subscription/upgradeto/${customerDetails?.tenantId}?subscription_id=${subscriptionInfo?.id}`,
				true
			)
				.then((res) => {
					if (res.data.success) {
						setSubscriptionDetails(res.data.records);
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						console.log(errorMsg, "errorMsg");
						ErrorMessage("Subscriptions", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Subscriptions", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Subscriptions", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	return (
		<div>
			<Header
				color="info"
				brand="Auscomp Cloud Services"
				links={<HeaderLinks dropdownHoverColor="info" />}
				fixed
			/>
			<Layout>
				<br />
				<div className={classesCSStyles.mx5}>
					<Card
						className={classNames(classesCSStyles.px5, classesCSStyles.minHeight)}>
						<CardHeader color="info" className="">
							<GridContainer>
								<GridItem xs={12} sm={6} md={6}>
									<h4 className={classesCSStyles?.labelAc}>Subscription Upgrade</h4>
								</GridItem>
							</GridContainer>
						</CardHeader>
						<CardBody
							className={classNames(
								classesCSStyles.accountSection,
								classesCSStyles.my10
							)}>
							{loading && (
								<Loading
									width={30}
									height={30}
									className={classesCSStyles.absoluteLoading}
								/>
							)}
							<GridContainer
								className={classNames(
									classesCSStyles.marginAuto,
									loading && classesCSStyles.loading
								)}>
								<GridItem
									xs={12}
									sm={12}
									md={12}
									className={classNames(loading ? classesCSStyles.loading : "")}>
									<GridContainer className={classNames(classesCSStyles.marginAuto)}>
										<GridItem xs={12} sm={12} md={12}>
											<div
												className={classNames(classesCSStyles?.subscriptionUpdateTitle)}>
												<div>FROM:</div>
												<Button
													size="sm"
													color="info"
													onClick={() => {
														// navigate("/csp-dashboard");
														window.location.href = "/csp-dashboard";
													}}>
													Cancel
												</Button>
											</div>
											<ul>
												<li
													className={classNames(classesCSStyles?.subscriptionUpdateLabel)}>
													<div>
														{subscriptionDetails?.subscription?.offerId} -{" "}
														{subscriptionDetails?.subscription?.offerName}
													</div>
												</li>
											</ul>
										</GridItem>
										<GridItem xs={12} sm={12} md={12}>
											<div className={classesCSStyles?.subscriptionUpdateTitle}>TO:</div>
											<ul>
												{subscriptionDetails?.subscriptions?.map((item) => {
													return (
														toSubscription == "" && (
															<li
																key={item.CatalogItemId}
																className={classNames(
																	classesCSStyles?.subscriptionUpdateLabel
																)}>
																<div>
																	<Radio
																		checked={toSubscription === item.CatalogItemId}
																		onChange={() => {
																			setToSubscription(item.CatalogItemId);
																		}}
																		value="Annual"
																		name="radio button enabled"
																		aria-label="Annual"
																		icon={
																			<FiberManualRecord className={classes3.radioUnchecked} />
																		}
																		checkedIcon={
																			<FiberManualRecord className={classes3.radioChecked} />
																		}
																		classes={{
																			checked: classes3.radio,
																			root: classes3.radioRoot,
																		}}
																	/>
																	{item.CatalogItemId} - {item.Title}
																</div>
															</li>
														)
													);
												})}
												{subscriptionDetails?.subscriptions?.map((item) => {
													return (
														toSubscription == item.CatalogItemId && (
															<li
																key={item.CatalogItemId}
																className={classNames(
																	classesCSStyles?.subscriptionUpdateLabel
																)}>
																<div>
																	<Radio
																		checked={toSubscription === item.CatalogItemId}
																		onChange={() => {
																			setToSubscription(item.CatalogItemId);
																		}}
																		value="Annual"
																		name="radio button enabled"
																		aria-label="Annual"
																		icon={
																			<FiberManualRecord className={classes3.radioUnchecked} />
																		}
																		checkedIcon={
																			<FiberManualRecord className={classes3.radioChecked} />
																		}
																		classes={{
																			checked: classes3.radio,
																			root: classes3.radioRoot,
																		}}
																	/>
																	{item.CatalogItemId} - {item.Title}
																</div>
															</li>
														)
													);
												})}
												{toSubscription != "" && (
													<>
														<li
															className={classNames(
																classesCSStyles?.subscriptionUpdateLabel,
																classesCSStyles?.py10
															)}>
															DESTINATION SUBSCRIPTION
														</li>
														<li
															className={classNames(
																classesCSStyles?.subscriptionUpdateLabel,
																classesCSStyles?.py10
															)}>
															<select
																id="newSubscription"
																{...register("newSubscription")}
																className="block w-full px-4 py-2 mt-1 border rounded-md shadow-sm focus:outline-none focus:ring focus:border-blue-300">
																<option value="">New Subscription</option>
															</select>
														</li>
														<li
															className={classNames(
																classesCSStyles?.subscriptionUpdateLabel,
																classesCSStyles?.py10
															)}>
															<span>
																{" "}
																<strong>QUANTITY</strong> : CURRENT :{" "}
																{subscriptionInfo?.quantity}
															</span>
														</li>
														<li
															className={classNames(
																classesCSStyles?.subscriptionUpdateLabel,
																classesCSStyles?.py10
															)}>
															QUANTITY TO UPGRADE
														</li>
														<li
															className={classNames(classesCSStyles?.subscriptionUpdateLabel)}>
															<CustomInput
																id="quantity"
																inputProps={{
																	type: "number",
																	placeholder: "Enter your quantity here",
																	...register("quantity"),
																	value: quantity,
																	onChange: (e) => {
																		setQuantity(e.target.value);
																	},
																}}
																formControlProps={{
																	fullWidth: false,
																	className: classes2.formControl,
																}}
															/>
															<div className="text-red-600 text-xs ml-3 pt-1">
																{errors.PO_Number?.message}
															</div>
														</li>
														<li
															className={classNames(
																classesCSStyles?.subscriptionUpdateLabel,
																classesCSStyles?.py10
															)}>
															<span>
																<strong>TERM </strong> : Current :{" "}
																{subscriptionInfo?.termDuration}
															</span>
														</li>
														<li
															className={classNames(
																classesCSStyles?.subscriptionUpdateLabel,
																classesCSStyles?.py10
															)}>
															CHANGE TO
														</li>
														<li
															className={classNames(
																classesCSStyles?.subscriptionUpdateLabel,
																classesCSStyles?.py10
															)}>
															<Select
																MenuProps={{
																	className: classes3.selectMenu,
																}}
																classes={{
																	select: classes3.select,
																}}
																value={termDuration}
																onChange={handleTermDuration}
																inputProps={{
																	id: "termDuration",
																	...register("termDuration"),
																}}>
																<MenuItem
																	classes={{
																		root: classes3.selectMenuItem,
																		selected: classes3.selectMenuItemSelected,
																	}}
																	value={"P1M"}>
																	{subscriptionInfo?.termDuration == "P1M"
																		? "No Change"
																		: "Monthly"}
																</MenuItem>
																<MenuItem
																	classes={{
																		root: classes3.selectMenuItem,
																		selected: classes3.selectMenuItemSelected,
																	}}
																	value={"P1Y"}>
																	{subscriptionInfo?.termDuration == "P1Y"
																		? "No Chang"
																		: "Annual"}
																</MenuItem>
															</Select>
														</li>
														<li
															className={classNames(
																classesCSStyles?.subscriptionUpdateLabel,
																classesCSStyles?.py10
															)}>
															<span>
																<strong>BILLING FREQUENCY </strong>: Current :{" "}
																{subscriptionInfo?.billingCycle}
															</span>
														</li>
														<li
															className={classNames(
																classesCSStyles?.subscriptionUpdateLabel,
																classesCSStyles?.py10
															)}>
															CHANGE TO
														</li>
														<li
															className={classNames(
																classesCSStyles?.subscriptionUpdateLabel,
																classesCSStyles?.py10
															)}>
															<Select
																MenuProps={{
																	className: classes3.selectMenu,
																}}
																classes={{
																	select: classes3.select,
																}}
																value={billingCycle}
																onChange={handleBillingCycle}
																inputProps={{
																	id: "billingCycle",
																	...register("billingCycle"),
																}}>
																<MenuItem
																	classes={{
																		root: classes3.selectMenuItem,
																		selected: classes3.selectMenuItemSelected,
																	}}
																	value={billingCycle}>
																	{"No Change"}
																</MenuItem>
															</Select>
														</li>
														<li
															className={classNames(
																classesCSStyles?.py10,
																classesCSStyles?.subscriptionUpdateLabel,
																classesCSStyles?.labelAc
															)}>
															Please note by upgrading this plan you agree to the currently
															committed term. No cancellation period is provided for plan
															upgrades.
														</li>
														<li className={classNames()}>
															<Button color="info" size="sm" onClick={handleSubmit(onSubmit)}>
																Confirm
															</Button>
															&nbsp;&nbsp;
															<Button
																color="danger"
																size="sm"
																onClick={() => {
																	// navigate("/csp-dashboard");
																	window.location.href = "/csp-dashboard";
																}}>
																Cancel
															</Button>
														</li>
													</>
												)}
											</ul>
										</GridItem>
									</GridContainer>
								</GridItem>
							</GridContainer>
						</CardBody>
					</Card>
				</div>
			</Layout>
		</div>
	);
}
